import React,{useEffect, useState} from 'react';
import { boxOauthHitting } from '../../../../base/utils';


const BoxSuccess=()=> {
  const [getMessgeInfo, setMessgeInfo] = useState('');

  const oauthBox=async()=> {
    let message:any = await boxOauthHitting();
    setMessgeInfo(message);
  }


    useEffect(()=> {
        oauthBox();
    },[]);

 return(
   <>
   {getMessgeInfo}
   </>
    )
}
export default BoxSuccess;